import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { fourSlopeMeasurementsState } from '../../../calculation.state';
import { MeasurementsAbstractComponent } from '../measurements-abastract.component';
import { MeasurementsType } from '../measurements.constants';
import { FormEvent } from '../../../../common/shared/constants';
import { FourSlopeMeasurementDto } from '../../../../../api/models/four-slope-measurement-dto';

@Component({
  selector: 'four-slopes',
  templateUrl: './four-slopes.component.html',
  styleUrls: ['./four-slopes.component.scss'],
})
export class FourSlopesComponent extends MeasurementsAbstractComponent implements OnInit, OnDestroy {
  @Output()
  eventEmitter = new EventEmitter<FormEvent<FourSlopeMeasurementDto>>();
  form!: UntypedFormGroup;
  formSubscription: any;
  @Input()
  initData: MeasurementsType | null = null;

  constructor(private _formBuilder: UntypedFormBuilder) {
    super();
  }

  ngOnInit(): void {
    this.setupForms();
  }

  ngOnDestroy() {
    this.formSubscription?.unsubscribe();
  }

  private setupForms() {
    const measurements = (this.initData as FourSlopeMeasurementDto) || fourSlopeMeasurementsState;
    this.form = this._formBuilder.group({
      triangleHeight: new UntypedFormControl(measurements.triangleHeight, [Validators.required]),
      triangleBase: new UntypedFormControl(measurements.triangleBase, [Validators.required]),
      trapezoidHeight: new UntypedFormControl(measurements.trapezoidHeight, [Validators.required]),
      trapezoidBase: new UntypedFormControl(measurements.trapezoidBase, [Validators.required]),
      ridgeLength: new UntypedFormControl(measurements.ridgeLength, [Validators.required]),
      splitHeightInTwoRows: new UntypedFormControl(measurements.splitHeightInTwoRows),
      chimneys: new UntypedFormControl(measurements.chimneys),
    });
    this.eventEmitter.emit({ value: this.form.value, valid: this.form.valid, unchanged: true });

    this.formSubscription = this.form.valueChanges.subscribe((measurements) => {
      ['triangleHeight', 'triangleBase', 'trapezoidHeight', 'trapezoidBase', 'ridgeLength'].forEach((key) => {
        if (measurements.hasOwnProperty(key)) {
          measurements[key] = Number(measurements[key]);
        }
      });
      this.eventEmitter.emit({ value: this.form.value, valid: this.form.valid });
    });
  }

  hasBaseMeasurementsError() {
    if (!this.form?.controls?.trapezoidBase?.value || !this.form?.controls?.ridgeLength?.value) {
      return false;
    }
    return Number(this.form?.controls?.trapezoidBase?.value) <= Number(this.form?.controls?.ridgeLength?.value);
  }
}
